<template>
    <div class="h-screen flex overflow-hidden bg-gray-100">
        <sidebar
            v-if="sidebarReady"
            :sidebarVisible="sidebarVisible"
            :collapsed="menuCollapsed"
            @toggleSidebar="toggleSidebar"
            @toggleMenuCollapsed="toggleMenuCollapsed"
        ></sidebar>
        <div class="flex flex-col w-0 flex-1 overflow-hidden">
            <navbar home-to="/dashboard" @toggleSidebar="toggleSidebar"></navbar>
            <router-view></router-view>
        </div>
        <navigation-shortcut-leader-indicator></navigation-shortcut-leader-indicator>
    </div>
</template>

<script>
import Navbar from "@/components/layout/workspace/navbar";
import Sidebar from "@/components/layout/customer/sidebar";
import NavigationShortcutLeaderIndicator from "@/components/navigation-shortcuts/leader-indicator";
import {registerNavigationShortcuts} from "@/utils/navigation-shortcuts";
import {getAuthToken} from "@/utils/auth-token";

export default {
    name: "customer-layout",
    components: {NavigationShortcutLeaderIndicator, Sidebar, Navbar},
    data() {
        return {
            sidebarVisible: false,
            menuCollapsed: false,
            unregisterNavigationShortcuts: null,
            sidebarReady: false,
        };
    },
    mounted() {
        this.loadMenuCollapsed();
        this.bootstrapSidebar();
        this.unregisterNavigationShortcuts = registerNavigationShortcuts({
            router: this.$router,
            store: this.$store,
        });
    },
    beforeUnmount() {
        if (typeof this.unregisterNavigationShortcuts === 'function') {
            this.unregisterNavigationShortcuts();
            this.unregisterNavigationShortcuts = null;
        }
    },
    metaInfo() {
        return {
            title: this.$store.state.settings.name,
            titleTemplate: () => this.$store.state.settings.name
        };
    },
    methods: {
        bootstrapSidebar() {
            const token = getAuthToken();
            if (!token) {
                this.sidebarReady = true;
                return;
            }

            if (this.$store && this.$store.state && this.$store.state.user && this.$store.state.user.role) {
                this.sidebarReady = true;
                return;
            }

            axios.get('api/auth/user').then((response) => {
                const data = response && response.data ? response.data : null;
                if (data && data.role) {
                    this.$store.commit('updateUser', data);
                }
            }).finally(() => {
                this.sidebarReady = true;
            });
        },
        loadMenuCollapsed() {
            try {
                this.menuCollapsed = localStorage.getItem('stage_menu_collapsed') === '1';
            } catch (e) {
                this.menuCollapsed = false;
            }
        },
        toggleMenuCollapsed(force = null) {
            if (force !== null) {
                this.menuCollapsed = force;
            } else {
                this.menuCollapsed = !this.menuCollapsed;
            }

            try {
                localStorage.setItem('stage_menu_collapsed', this.menuCollapsed ? '1' : '0');
            } catch (e) {
                // Ignore storage errors in private mode.
            }
        },
        toggleSidebar(force = null) {
            if (force !== null) {
                this.sidebarVisible = force;
            } else {
                this.sidebarVisible = !this.sidebarVisible;
            }
        }
    }
}
</script>
